import {
  FormControl,
  FormLabel,
  GridItem,
  Input,
  Text
} from '@chakra-ui/react';
import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { DeploymentFormErrors } from '.';
import { FormError } from '../form/FormError';
import { IDeploymentForm } from './type';
import StepBox from './stepBox';

type Props = {
  register: UseFormRegister<IDeploymentForm>;
  errors: DeploymentFormErrors;
};

const SetMetadata: FC<Props> = ({ register, errors }) => {
  const inputBorderColor = 'gray.300';
  return (
    <StepBox heading='1. Program Metadata'>
      <GridItem colSpan={[1, 2, 3, 4]}>
        <Text color='gray.200'>
          Please set a reward program Name (max 32 characters) which will be
          displayed to users, and a starting date/time for when the program
          should be live. If you want the program to be live instantly, please
          use the current time.
        </Text>
      </GridItem>

      <GridItem>
        <FormControl isRequired isInvalid={!!errors.name}>
          <FormLabel>Name</FormLabel>
          <Input
            id='name'
            type='text'
            maxLength={32}
            borderColor={inputBorderColor}
            {...register('name')}
          />
        </FormControl>
        {!!errors.name && <FormError>{errors.name.message}</FormError>}
      </GridItem>

      <GridItem colStart={[1, 2]}>
        <FormControl isRequired isInvalid={!!errors.startTime}>
          <FormLabel whiteSpace='nowrap' overflow='auto'>
            Start time ({Intl.DateTimeFormat().resolvedOptions().timeZone})
          </FormLabel>
          <Input
            id='startTime'
            type='datetime-local'
            style={{ colorScheme: 'dark' }}
            borderColor={inputBorderColor}
            {...register('startTime')}
          />
          {!!errors.startTime && (
            <FormError>{errors.startTime.message}</FormError>
          )}
        </FormControl>
      </GridItem>
    </StepBox>
  );
};

export default SetMetadata;
